import "./SnackbarComp.css";
import { defineComponent as a, getCurrentInstance as p, resolveComponent as c, openBlock as i, createBlock as m, mergeProps as _, withCtx as o, renderSlot as n } from "vue";
import { c as d, v as u } from "./main.88c600c1.js";
import { _ as f } from "./_plugin-vue_export-helper.dad06003.js";
const v = a({
  components: { VSnackbar: d },
  props: {
    id: {
      type: String,
      required: !0
    }
  },
  setup() {
    const e = p();
    e && !e.appContext.mixins.some((s) => {
      var t;
      return (t = s.computed) == null ? void 0 : t.$vuetify;
    }) && e.appContext.app.use(u);
  }
});
function l(e, s, t, $, C, k) {
  const r = c("v-snackbar");
  return i(), m(r, _({ class: "v-theme--customTheme" }, e.$props), {
    actions: o(() => [
      n(e.$slots, "actions", {}, void 0, !0)
    ]),
    activator: o(() => [
      n(e.$slots, "activator", {}, void 0, !0)
    ]),
    default: o(() => [
      n(e.$slots, "default", {}, void 0, !0)
    ]),
    _: 3
  }, 16);
}
const h = /* @__PURE__ */ f(v, [["render", l], ["__scopeId", "data-v-6994fdc0"]]);
export {
  h as SnackbarComp
};
//# sourceMappingURL=SnackbarComp.js.map
